// Port of api/fuel/app/classes/insights/game/players.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'players',
    priority: 7,
    requires: ['init'],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.has_plays) return {}

        var user_id = owner.get_id()
        var username = owner.get_name().toLowerCase()
        var playersRaw = this._data.players_raw
        var playsRaw = this._data.plays_raw

        var data = {
            opponents: [],
            winsByCount: [],
            startingAdvantage: {
                startWins: 0, startTotal: 0, startRate: 0,
                otherWins: 0, otherTotal: 0, otherRate: 0
            },
            newPlayerGames: 0,
            soloVsGroup: { solo: 0, group: 0 }
        }

        // Index plays by play_id
        var playsById = {}
        for (var pi = 0; pi < playsRaw.length; pi++) {
            playsById[playsRaw[pi].play_id] = playsRaw[pi]
        }

        // Aggregate per opponent
        var opponents = []
        var opponentsByUser = {}
        var opponentsByName = {}
        var winsByCount = {}
        var startWins = 0, startTotal = 0, otherWins = 0, otherTotal = 0
        var newPlayerGames = 0

        for (var i = 0; i < playersRaw.length; i++) {
            var player = playersRaw[i]
            var playId = player.play_id
            var playerUserId = parseInt(player.user_id, 10) || 0
            var playerName = player.player_name
            var playerUsername = player.player_username
            var isWin = parseInt(player.player_win, 10) || 0
            var isStart = parseInt(player.player_start, 10) || 0
            var score = player.player_score
            var isNew = parseInt(player.player_new, 10) || 0

            if (isNew && playsById[playId]) newPlayerGames++

            if (this.isSelf(player, user_id, username)) {
                if (playsById[playId]) {
                    var playerCount = parseInt(playsById[playId].play_players, 10) || 0
                    if (playerCount > 0) {
                        if (!winsByCount[playerCount]) {
                            winsByCount[playerCount] = { count: playerCount, wins: 0, total: 0, rate: 0 }
                        }
                        winsByCount[playerCount].total++
                        if (isWin) winsByCount[playerCount].wins++
                    }
                }

                if (isStart) {
                    startTotal++
                    if (isWin) startWins++
                } else {
                    otherTotal++
                    if (isWin) otherWins++
                }
                continue
            }

            // Find or create opponent entry
            var index = false

            if (playerUserId && opponentsByUser[playerUserId] !== undefined) {
                index = opponentsByUser[playerUserId]
            }

            if (index === false && playerName && opponentsByName[playerName] !== undefined) {
                index = opponentsByName[playerName]
            }

            if (index === false) {
                index = opponents.length
                opponents.push({
                    name: playerName ? playerName : 'Unnamed',
                    userId: playerUserId,
                    plays: 0, wins: 0, losses: 0,
                    scores: [],
                    bestScore: null,
                    lastPlayed: null
                })
            }

            if (playerUserId) opponentsByUser[playerUserId] = index
            if (playerName) opponentsByName[playerName] = index

            opponents[index].plays++
            if (isWin) opponents[index].wins++
            else opponents[index].losses++

            if (playsById[playId]) {
                var playDate = parseInt(playsById[playId].play_date, 10) || 0
                if (playDate > 0 && (opponents[index].lastPlayed === null || playDate > opponents[index].lastPlayed)) {
                    opponents[index].lastPlayed = playDate
                }
            }

            if (score !== '' && score !== null && score !== undefined) {
                var scoreVal = parseFloat(score)
                if (!isNaN(scoreVal)) {
                    opponents[index].scores.push(scoreVal)
                    if (opponents[index].bestScore === null || scoreVal > opponents[index].bestScore) {
                        opponents[index].bestScore = scoreVal
                    }
                }
            }
        }

        // Finalize opponents
        for (var oi = 0; oi < opponents.length; oi++) {
            var opp = opponents[oi]
            opp.avgScore = opp.scores.length > 0 ? Math.round(opp.scores.reduce(function(a, b) { return a + b }, 0) / opp.scores.length * 10) / 10 : null
            delete opp.scores
            if (opp.userId) this._references.users.push(opp.userId)
        }

        var limit = detail ? 100 : 5
        opponents = Util.sort_by_field(opponents, 'plays', 'desc')
        data.opponentsTotal = opponents.length
        data.opponents = opponents.slice(0, limit)

        // Finalize win rate by count
        var wbcKeys = Object.keys(winsByCount).sort(function(a, b) { return a - b })
        var winsByCountArr = []
        for (var wk = 0; wk < wbcKeys.length; wk++) {
            var entry = winsByCount[wbcKeys[wk]]
            entry.rate = entry.total > 0 ? Math.round((100 / entry.total) * entry.wins * 10) / 10 : 0
            winsByCountArr.push(entry)
        }
        data.winsByCount = winsByCountArr

        // Starting advantage
        data.startingAdvantage.startWins = startWins
        data.startingAdvantage.startTotal = startTotal
        data.startingAdvantage.startRate = startTotal > 0 ? Math.round((100 / startTotal) * startWins * 10) / 10 : 0
        data.startingAdvantage.otherWins = otherWins
        data.startingAdvantage.otherTotal = otherTotal
        data.startingAdvantage.otherRate = otherTotal > 0 ? Math.round((100 / otherTotal) * otherWins * 10) / 10 : 0

        data.newPlayerGames = newPlayerGames

        // Solo vs group
        for (var sv = 0; sv < playsRaw.length; sv++) {
            var svPlayers = parseInt(playsRaw[sv].play_players, 10) || 0
            if (svPlayers === 1) {
                data.soloVsGroup.solo += parseInt(playsRaw[sv].play_count, 10) || 0
            } else if (svPlayers > 1) {
                data.soloVsGroup.group += parseInt(playsRaw[sv].play_count, 10) || 0
            }
        }

        return {
            players: data
        }

    }
})
